import { baseApi } from './baseApi';

export const financeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getExpenseAccounts: builder.query({
      query: () => '/finance/expense-accounts',
      providesTags: ['Finance'],
    }),
    getExpenses: builder.query({
      query: (params) => ({
        url: '/finance/expenses',
        params,
      }),
      providesTags: ['Finance'],
    }),
    createExpense: builder.mutation({
      query: (data) => ({
        url: '/finance/expenses',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Finance', 'Report'],
    }),
  }),
});

export const { useGetExpensesQuery, useCreateExpenseMutation } = financeApi;
export const { useGetExpenseAccountsQuery } = financeApi;

